import React from "react";
import { Text } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import { ProgrammingStructure } from "@models/ISchema";
import Modal from "@components/modal";

interface VisibilityStructureModalProps {
  isOpen?: boolean;
  programmingStructure?: ProgrammingStructure;
  onClose: () => void;
  onConfirm: () => void;
}

const VisibilityStructureModal = ({
  isOpen,
  programmingStructure,
  onClose,
  onConfirm,
}: VisibilityStructureModalProps) => {
  const { t } = useTranslation();
  const willBeVisible = !programmingStructure?.programmingStructureStats?.isVisible;

  return (
    <Modal
      typeState="confirm"
      show={isOpen}
      title={t(
        `programming-structures.modals.visibility-change.title-${willBeVisible ? "show" : "hide"}`,
      )}
      textButtonPrincipal={t(
        `programming-structures.modals.visibility-change.confirm-${
          willBeVisible ? "show" : "hide"
        }`,
      )}
      textButtonSecondary={t("programming-structures.modals.visibility-change.cancel")}
      onClose={onClose}
      onClickPrincipal={onConfirm}
      onClickSecondary={onClose}
    >
      <Text>
        {t(
          `programming-structures.modals.visibility-change.description-${
            willBeVisible ? "show" : "hide"
          }`,
          {
            code: programmingStructure?.code,
            name: programmingStructure?.name,
          },
        )}
      </Text>
    </Modal>
  );
};

export default VisibilityStructureModal;
